import { gql, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { Input } from "components/base/Form";
import { InlineSpinner } from "components/base/Spinner";
import { useState } from "react";
import { IoRefreshCircleOutline } from "react-icons/io5";
import { FixedSizeList } from "react-window";
import { searchByProp } from "utils/search";

export const FETCH_PRODUCTS = gql`
  query FETCH_PRODUCTS($company: String, $isSalable: Boolean) {
    products(
      productType: "normal"
      isActive: true
      isSalable: $isSalable
      company: $company
    ) {
      results {
        id
        company
        odooId
        odooIdInc
        name
        number
      }
    }
  }
`;

const ProductSelector = ({ onSelect, className = "", variables = {} }) => {
  const { loading, error, data, refetch } = useQuery(FETCH_PRODUCTS, {
    variables,
    notifyOnNetworkStatusChange: true,
  });
  const [searchText, setSearchText] = useState("");
  const [showOptions, setShowOptions] = useState(false);

  if (loading)
    return (
      <div>
        <InlineSpinner text={null} size={16} />
      </div>
    );
  if (error) return <Errors error={error} />;

  const optionsToShow = data.products.results.filter((i) =>
    searchByProp(i, ["name", "number"], searchText),
  );

  function render({ data, index, style }) {
    const option = data[index];

    return (
      <div
        className="cursor-pointer border-b dark:border-gray-700 px-4 hover:bg-gray-200 dark:hover:bg-gray-700 w-full h-full flex items-center"
        key={index}
        onClick={() => onSelect(option)}
        style={style}
      >
        {option.company !== "UNSET" && `(${option.company}) `}[{option.number}]{" "}
        {option.name}
      </div>
    );
  }

  function refreshHandler() {
    refetch();
  }

  return (
    <div
      className={`
            ${showOptions ? "z-10" : "z-0"} w-full relative ${className}`}
    >
      <div
        className={`fixed inset-0
                ${showOptions ? " visible" : " invisible"}
                `}
        onClick={() => setShowOptions(false)}
      ></div>
      <div className="relative">
        <Input
          className="w-full relative z-10"
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
          onFocus={() => setShowOptions(true)}
        />
        <Button
          className="absolute right-2 top-0 bottom-0 z-20"
          onClick={refreshHandler}
          icon={<IoRefreshCircleOutline size={21} />}
          loading={loading}
        />
      </div>
      <div
        className={`absolute w-full rounded overflow-auto z-20 shadow-lg bg-white dark:bg-gray-800
                ${showOptions ? " visible" : " invisible"}
            `}
      >
        <FixedSizeList
          height={300}
          itemSize={36}
          width="100%"
          itemData={optionsToShow}
          itemCount={optionsToShow.length}
        >
          {render}
        </FixedSizeList>
      </div>
    </div>
  );
};

export default ProductSelector;
